var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5161 11.75H3.39111C3.15905 11.75 2.93649 11.6578 2.77239 11.4937C2.6083 11.3296 2.51611 11.1071 2.51611 10.875V3H10.3911V10.875C10.3911 11.1071 10.2989 11.3296 10.1348 11.4937C9.97073 11.6578 9.74817 11.75 9.5161 11.75Z",
    stroke: "#424242",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14062 9.125V5.625",
    stroke: "#424242",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76611 9.125V5.625",
    stroke: "#424242",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3H11.6569",
    stroke: "#424242",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65429 1.25H5.0293C4.79723 1.25 4.57467 1.34219 4.41058 1.50628C4.24648 1.67038 4.1543 1.89293 4.1543 2.125V3H8.52929V2.125C8.52929 1.89293 8.43711 1.67038 8.27301 1.50628C8.10892 1.34219 7.88636 1.25 7.65429 1.25Z",
    stroke: "#424242",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteColumn);
export default __webpack_public_path__ + "static/media/delete-column.a05105ac662307e6935f05c25cd91cf9.svg";
export { ForwardRef as ReactComponent };